import { useState } from 'preact/hooks';
import { api } from '../state';

const resetToken = () => (location.hash.startsWith('#reset=') ? location.hash.slice(7) : '');

export function Login() {
  const [mode, setMode] = useState<'login' | 'forgot' | 'sent' | 'reset' | 'done'>(resetToken() ? 'reset' : 'login');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: Event, run: (data: Record<string, string>) => Promise<void>) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await run(Object.fromEntries(new FormData(e.currentTarget as HTMLFormElement)) as Record<string, string>);
    } catch (err) {
      setError((err as Error).message);
    }
    setBusy(false);
  }

  const header = (title: string) => (
    <>
      <img src="/icon-192.png" alt="" width={64} height={64} />
      <h1>{title}</h1>
    </>
  );

  return (
    <div class="login">
      {mode === 'login' && (
        <form class="card login-card" onSubmit={(e) => submit(e, async (d) => { await api('/login', { method: 'POST', body: JSON.stringify(d) }); location.reload(); })}>
          {header('Guardian Chat')}
          <label class="field"><span>Email</span><input name="email" type="email" autocomplete="username" required /></label>
          <label class="field"><span>Password</span><input name="password" type="password" autocomplete="current-password" required /></label>
          {error && <p class="error">{error}</p>}
          <button class="btn primary" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
          <p><button type="button" class="link" onClick={() => { setError(''); setMode('forgot'); }}>Forgot your password?</button></p>
        </form>
      )}
      {mode === 'forgot' && (
        <form class="card login-card" onSubmit={(e) => submit(e, async (d) => { await api('/password/forgot', { method: 'POST', body: JSON.stringify(d) }); setMode('sent'); })}>
          {header('Reset password')}
          <p class="muted">Enter your email and we’ll send you a link to choose a new password.</p>
          <label class="field"><span>Email</span><input name="email" type="email" autocomplete="username" required /></label>
          {error && <p class="error">{error}</p>}
          <button class="btn primary" disabled={busy}>Send reset link</button>
          <p><button type="button" class="link" onClick={() => setMode('login')}>Back to sign in</button></p>
        </form>
      )}
      {mode === 'sent' && (
        <div class="card login-card">
          {header('Check your email')}
          <p class="muted">If that email has a Guardian Chat account, a reset link is on its way. It works once and expires in an hour.</p>
          <button class="btn" onClick={() => setMode('login')}>Back to sign in</button>
        </div>
      )}
      {mode === 'reset' && (
        <form
          class="card login-card"
          onSubmit={(e) =>
            submit(e, async (d) => {
              if (d.password !== d.confirm) throw new Error('The passwords don’t match.');
              await api('/password/reset', { method: 'POST', body: JSON.stringify({ token: resetToken(), password: d.password }) });
              history.replaceState(null, '', '/');
              setMode('done');
            })
          }
        >
          {header('Choose a new password')}
          <label class="field"><span>New password (10+ characters)</span><input name="password" type="password" minLength={10} autocomplete="new-password" required /></label>
          <label class="field"><span>Confirm new password</span><input name="confirm" type="password" minLength={10} autocomplete="new-password" required /></label>
          {error && <p class="error">{error}</p>}
          <button class="btn primary" disabled={busy}>Save password</button>
        </form>
      )}
      {mode === 'done' && (
        <div class="card login-card">
          {header('Password updated')}
          <p class="muted">You can sign in with your new password now. You’ve been signed out on other devices.</p>
          <button class="btn primary" onClick={() => setMode('login')}>Sign in</button>
        </div>
      )}
    </div>
  );
}
